import { Container } from '../../components/container';
import styled from 'styled-components';
import { mq } from '../../styles/mq';
import { theme } from '../../styles/theme';

export const StyledFooter = styled.footer`
  position: relative;
  margin: 0;
  color: ${theme.colors.text};
  font-size: 1.7rem;
  line-height: 2.5rem;
  @media (max-width: 392px) {
    font-size: 1.5rem;
  }
  border-top: 1px solid ${theme.colors.text};
  padding: 3rem 0 6rem 0;
  background-color: ${theme.colors.background};
  z-index: 9000;
  ${mq.medium} {
    //margin-top: 8rem;
  }

  ${mq.large} {
    //margin-top: 12rem;
  }
  ${mq.xlarge} {
    font-size: 2rem;
    p {
      line-height: 3rem;
    }
    padding: 4rem 0 6rem 0;
  }

  ${Container} {
    text-align: center;
  }
`;

export const Authors = styled.div`
  grid-area: authors;
  margin: 0 0 2rem 0;
  ${mq.xlarge} {
    margin: 0 0 3rem 0;
  }
  > div {
    margin: 1.8rem 0;
    div {
      display: grid;
      grid-template-columns: calc(50% - 0.5rem) calc(50% - 0.5rem);
      column-gap: 1rem;
    }
    p {
      margin: 0;
    }
    p:first-child {
      text-align: right;
    }
    p:last-child {
      text-align: left;
    }
  }
`;

export const About = styled.div`
  margin: 2rem 0 2rem 0;
  grid-area: about;
  ${mq.xlarge} {
    margin: 3rem 0 3rem 0;
  }
`;

export const Social = styled.div``;

export const SocialLinks = styled.ul`
  margin: 1.6rem 0 2rem;
  padding: 0;
  list-style: none;
  line-height: 0;
  ${mq.xlarge} {
    margin: 2rem 0 3rem;
  }

  li {
    display: inline-block;
    padding: 0;
    margin: 0;
    height: 3rem;
    margin-right: 2rem;
    ${mq.xlarge} {
      height: 4.2rem;
      margin-right: 3rem;
    }
    &:last-child {
      margin-right: 0;
    }
  }

  a {
    display: inline-block;
    font-size: 5.5rem;
    width: 3rem;
    height: 3rem;
    ${mq.smallOnly} {
      width: 2.5rem;
      height: 2.5rem;
    }
    ${mq.medium} {
      width: 3.6rem;
      height: 3.6rem;
    }
    ${mq.xlarge} {
      width: 4.2rem;
      height: 4.2rem;
    }
    color: black;
    transition: all 0.3s;
    overflow: hidden;
    border-radius: 50%;

    svg {
      display: block;
      fill: none;

      width: 100%;
    }

    &:hover,
    &:focus {
      color: black;
    }
  }
`;

export const Heading = styled.h4`
  font-weight: 800;
  font-size: 1.7rem;
  text-transform: uppercase;
  margin: 0 0 1.6rem 0;
  ${mq.xlarge} {
    margin: 0 0 2rem 0;
    font-size: 2rem;
  }
  &:not(:first-child) {
    //margin-top: 6rem;
  }
`;

export const Copyright = styled.p`
  margin-top: 2rem;
  font-size: 1.5rem;
  opacity: 0.7;
  grid-area: credit;
  ${mq.xlarge} {
    margin-top: 3rem;
    font-size: 1.7rem;
  }
`;
